const favourite_tv_show = `Yksi suosikkiohjelmistani on suomalainen komediasarja nimeltä "Luottomies.
Se on hauska esitys, joka saa minut nauramaan ja tuntemaan oloni onnelliseksi.
Esitys kertoo Luottomies-nimisestä miehestä, joka auttaa ihmisiä heidän ongelmissaan,
mutta usein hän pahentaa asioita.
Hän on kiltti ihminen, mutta hän ei ole kovin hyvä työssään, mikä johtaa moniin hauskoihin tilanteisiin.
Esityksen hahmot ovat kaikki erittäin hauskoja ja mielenkiintoisia.
He ovat erilaisia persoonallisuuksia ja tekevät esityksestä viihdyttävää katsottavaa.
Näyttelijät tekevät hienoa työtä herättääkseen hahmot eloon ja tehdäkseen esityksestä nautinnollisen kaikille.
"Luottomies" on esitys, joka saa kuka tahansa nauramaan ja unohtamaan huolensa.
Se on kevytmielinen sarja, joka sopii täydellisesti rentoutumiseen ja hauskanpitoon.
Esityksen katsominen saa aina hymyn huulille ja tekee päivästäni paremman.`;

export default favourite_tv_show;